import { useState } from 'react'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { TaskActionButton } from 'gga-ui-library'
import { Button, CircularProgress, Link } from '@material-ui/core'
import { SaveAlt } from '@material-ui/icons'

import { showNotification } from '../Notifications/NotificationActionCreator'
import apiConfig from '../../config/apiConfig'
import DownloadPopup from './DownloadPopup'

const DownloadFileContainer = ({
  jobId,
  fileName,
  lastUpdated,
  listingType = false,
  nameButton = false,
  selectedPhase = '',
  urlZip1,
  urlZip2,
  tcin,
}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const isASB = selectedPhase === 'AGENCY_SCENE_BUILDING'

  const downloadFileHandler = async (event) => {
    event?.stopPropagation()
    if (isASB) {
      setOpen(true)
      return ''
    }
    setLoading(true)
    try {
      const verifyUrl = `${apiConfig.task.downloadUrl}/${jobId}/${fileName}`
      const verifyRes = await axios.get(verifyUrl)
      if (!verifyRes || verifyRes.status !== 200) {
        throw new Error('File verification failed')
      }
      if (verifyRes?.data?.pre_signed_url) {
        if (verifyRes.data.has_pre_signed_url_expired) {
          dispatch(showNotification(true, 'File no longer exists', 'error'))
        } else {
          dispatch(showNotification(true, 'Download started', 'success'))
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = verifyRes.data.pre_signed_url
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      } else {
        dispatch(
          showNotification(
            true,
            'Your download will begin shortly. Large files may take a few minutes to start.',
            'success',
            15000
          )
        )
        const fileUrl = `${apiConfig.task.fileDownload}/${jobId}?key=${apiConfig.apiKey}&file_name=${fileName}&is_download=true`
        const downloadRes = await fetch(fileUrl)
        if (!downloadRes.ok) {
          const errorData = await downloadRes.json().catch(() => null)
          const errorMessage = errorData?.error?.includes('No job found')
            ? 'File no longer available in storage'
            : downloadRes.status === 404
            ? 'File not found'
            : 'Error downloading file'
          throw new Error(errorMessage)
        }
        const blob = await downloadRes.blob()
        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(blobUrl)
        dispatch(
          showNotification(
            true,
            `Successfully downloaded ${fileName}`,
            'success'
          )
        )
      }
    } catch (error) {
      dispatch(
        showNotification(true, error.message || 'Download failed', 'error')
      )
    } finally {
      setLoading(false)
    }
  }

  if (nameButton) {
    return (
      <Button onClick={downloadFileHandler} color="primary" variant="outlined">
        <SaveAlt /> &nbsp;{fileName} &nbsp;
        {loading ? <CircularProgress size={20} /> : null}
      </Button>
    )
  }

  let disableButton = true
  if ((isASB && (urlZip1 || urlZip2)) || (jobId && fileName)) {
    disableButton = false
  }

  return (
    <>
      {listingType ? (
        <Link component="button" variant="body2" onClick={downloadFileHandler}>
          {fileName} {lastUpdated && '@'} {lastUpdated.split('T')[1]}
        </Link>
      ) : (
        <TaskActionButton
          onClick={downloadFileHandler}
          disableBtn={disableButton}
          buttonType={loading ? 'loading' : 'download'}
          buttonName={loading ? 'Preparing to download' : 'Download files'}
        />
      )}
      <DownloadPopup
        open={open}
        onClose={() => {
          setOpen(false)
        }}
        urlZip1={urlZip1}
        urlZip2={urlZip2}
        tcin={tcin}
      />
    </>
  )
}

export default DownloadFileContainer
